function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M253.22,200.39l-.46-.46L221.56,177V127.25c0-47.4-29.4-80.5-71.5-80.5s-71.5,33.1-71.5,80.5V177L47.21,200.08l-.46.45a9.51,9.51,0,0,0,6.72,16.22h193a9.58,9.58,0,0,0,6.78-16.36Zm-176.87-.64,16-11.73.46-.46a9.46,9.46,0,0,0,2.79-6.74V127.25c0-43.87,27.37-63.5,54.5-63.5,37.65,0,54.5,31.89,54.5,63.5v53.56a9.48,9.48,0,0,0,2.8,6.76l.46.46,16,11.72Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M150.06,253.25a44.93,44.93,0,0,0,36-18h-72A44.93,44.93,0,0,0,150.06,253.25Z"
});

var SvgNotification1 = function SvgNotification1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification_1.e96c590a.svg";
export { ForwardRef as ReactComponent };